import type { IEvent } from './Event.interface';

export default class Event implements IEvent {
  name: String;
  handler: Function;
  context: Object;
  once: Boolean;

  /**
   * Constructor
   * @param {IEvent} data
   */
  constructor(data?: IEvent) {
    this.name = data?.name;
    this.handler = data?.handler;
    this.context = data?.context;
    this.once = data?.once === true;
  }
}
